import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Episodes from "../pages/episodes/page";
import Characters from "../pages/characters/page";
import Ending from "../pages/ending/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/episodes",
    element: <Episodes />,
  },
  {
    path: "/characters",
    element: <Characters />,
  },
  {
    path: "/ending",
    element: <Ending />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;